import { render, staticRenderFns } from "./player-list.vue?vue&type=template&id=24a7e0e4&scoped=true&"
import script from "./player-list.vue?vue&type=script&lang=js&"
export * from "./player-list.vue?vue&type=script&lang=js&"
import style0 from "./player-list.vue?vue&type=style&index=0&id=24a7e0e4&prod&scoped=true&lang=scss&"
import style1 from "./player-list.vue?vue&type=style&index=1&id=24a7e0e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7e0e4",
  null
  
)

export default component.exports